import { CasinoPlayerActivityAPIMessageChannels } from "../message";
export const CasinoPlayerActivityAPIQuery_Types = CasinoPlayerActivityAPIMessageChannels;
//# sourceMappingURL=casinoPlayerActivity.js.map